document.addEventListener('DOMContentLoaded', () => {
  initFishTownCTA();
});

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('.ft-cta');

  if (section) {
    initFishTownCTA(section);
  }
});

function initFishTownCTA(section = document.querySelector('.ft-cta')) {
  if (!section) return;

  // The CTA is intentionally lightweight.
  // No external libraries or additional functionality are required.
}